module.exports = "/images/77b0b4f-mavric_logo.png";